// Data layer for the published-setlist view. One cookie-authed GET /api/setlists/:id.

export interface SetlistMeta { setlistId: string; teamId: string; ownerUserId: string; name: string; createdAt: string; updatedAt: string; }
export interface SetlistItem { position: number; shareId: string; songId: string | null; songName: string | null; }
export type SetlistResult =
  | { ok: true; setlist: SetlistMeta; items: SetlistItem[] }
  | { ok: false; needsAuth?: boolean; notFound?: boolean };

export async function fetchPublishedSetlist(setlistId: string, apiBase = '', fetchImpl: typeof fetch = fetch): Promise<SetlistResult> {
  try {
    const res = await fetchImpl(`${apiBase}/api/setlists/${setlistId}`, { credentials: 'include' });
    if (res.status === 401) return { ok: false, needsAuth: true };
    if (res.status === 404) return { ok: false, notFound: true };
    if (!res.ok) return { ok: false };
    const body = await res.json() as any;
    return { ok: true, setlist: body.setlist, items: Array.isArray(body.items) ? body.items : [] };
  } catch {
    return { ok: false };
  }
}
